import { render } from "./ParamChargeUnitPageList.vue?vue&type=template&id=22fa36be&scoped=true&ts=true"
import script from "./ParamChargeUnitPageList.vue?vue&type=script&lang=ts"
export * from "./ParamChargeUnitPageList.vue?vue&type=script&lang=ts"

import "./ParamChargeUnitPageList.vue?vue&type=style&index=0&id=22fa36be&lang=sass&scoped=true"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22fa36be"]])

export default __exports__